// /src/hooks/useBookAppointment.js
import { useState } from 'react';
import { useToast } from '@chakra-ui/react';
import API from '../api/axiosConfig';

const useBookAppointment = () => {
    const [bookingError, setBookingError] = useState(null);
    const [isBooking, setIsBooking] = useState(false);
    const toast = useToast();

    const bookAppointment = async (_pos, date, time, _at, isReschedule, isPlanned, appointmentData) => {
        setIsBooking(true);
        setBookingError(null);

        const appointmentDateTime = `${date} ${time}`;
        
        try {
            if (isReschedule) {
                // For rescheduling, appointmentData should be the full appointment object with AptData (JWT token)
                const aptDataToken = appointmentData?.AptData;
                
                if (!aptDataToken) {
                    throw new Error('Appointment data token is required for rescheduling');
                }
                
                console.log("Rescheduling appointment with token");
                
                // Use the nested format with JWT token
                const response = await API.post('/appointments/web/change', {
                    reschedule: aptDataToken,
                    AptDateTime: appointmentDateTime
                });
                
                return response.data;
            } else {
                // Booking new or planned appointment
                const payload = {
                    aptdatetime: appointmentDateTime,
                    isReschedule: false,
                    isPlanned: isPlanned,
                    _pos: _pos
                };

                if (!isPlanned) {
                    payload._at = _at;
                } else {
                    // For planned appointments, AptData is the token
                    payload.AptData = appointmentData;
                }
                
                console.log("Booking appointment:", payload);
                const response = await API.post('/appointments/web/book', payload);
                return response.data;
            }

        } catch (error) {
            console.error("Error in bookAppointment:", error);
            
            let description = "There was an error processing your request. Please try again.";

            if (error.response) {
                if (error.response.status === 403) {
                    const uuid = localStorage.getItem('UUID');
                    toast({
                        title: "Session Expired",
                        description: "Your session has expired. You will be redirected to the login page.",
                        status: "warning",
                        duration: null,
                        isClosable: true,
                    });
                    setTimeout(() => {
                        window.location.href = uuid ? `/${uuid}` : "/";
                    }, 2000);
                } else if (error.response.data?.message) {
                    description = error.response.data.message;
                } else if (error.response.data?.error) {
                    description = error.response.data.error;
                }
            } else if (error.message) {
                description = error.message;
            }

            setBookingError(description);
            throw error;
        } finally {
            setIsBooking(false);
        }
    };

    return { bookAppointment, isBooking, bookingError };
};

export default useBookAppointment;